import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { saveSessionStationObservations } from '../../services/StationObservations'

function getErrorMessage(errorMessage) {
  const defaultMessage = {
    title: 'mobilePaymentsErrorTitle',
    message: 'mobilePaymentsErrorMessage',
  }

  if (!errorMessage) return defaultMessage

  return defaultMessage
}

function PaymentsErrorPage(props) {
  const { t } = useTranslation()

  const errorWithMessage = getErrorMessage()

  const skipPayments = useCallback(() => {
    saveSessionStationObservations('[Kiosk Virtual: Erro Pagamentos]')
    props.history.push('/thank-you')
  }, [])

  return (
    <div className="container">
      <div>
        <div className="home-top text-center pt-4">
          <div className="container">
            <div onClick={() => props.history.push('/start')}>
              <img src={require(`../../assets/images/logo.png`)} alt="Guerin" />
            </div>
          </div>
        </div>
        <div className="main-inicial">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 pr-5 pl-5 text-center">
                <h2 className="text-uppercase color-grey"><b>{t(errorWithMessage.title)}</b></h2>
              </div>
              <div className="col-12 pb-5 pl-4 pr-4 pt-3 text-center">
                {errorWithMessage.message ? <h2 className="color-green">{t(errorWithMessage.message)}</h2> : null}
              </div>
              <div className="col-6 text-center pb-5">
                <div onClick={() => props.history.push('/payments')} className='btn btn-green cursor'>{t('mobilePaymentsTryAgain')}</div>
              </div>
              <div className="col-6 text-center pb-5">
                <div onClick={skipPayments} className='btn btn-hollow btn-green-hollow cursor'>{t('mobileSkipPayments')}</div>
              </div>
              <div className="col-6">
                <a href="tel:210100200" className="btn btn-green w-100 phone upper">
                  {t('phone')}
                </a>
              </div>
              <div className="col-6">
                <a href="mailto:centralreservas@guerin.com.pt" className="btn btn-green w-100 mail upper">
                  {t('email')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export default PaymentsErrorPage